import { memo, useRef } from 'react';
import styles from './AdvtBgVideo.module.css';

import bgVideo from '../../assets/video/bgVideoAdvt.webm';
import bgPoster from '../../assets/images/bgPosterAdvt.webp';

export const AdvtBgVideo = memo(() => {
  const videoRef = useRef(null);

  return (
    <div className={styles.bgVideoWrapper}>
      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={bgPoster}
        ref={videoRef}
      >
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
});
